const COTIZACION_API_PATH = '/origina-api/cotizacion';

const normalizeText = (value = '') => String(value)
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

const parsePercent = (value) => {
  const parsed = Number.parseFloat(String(value ?? '').replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
};

export const getCotizacionTowerCode = (towerValue) => {
  const normalizedTower = normalizeText(towerValue);

  if (normalizedTower === 't1' || /\btorre\s*1\b/.test(normalizedTower)) return 't1';
  if (normalizedTower === 't2' || /\btorre\s*2\b/.test(normalizedTower)) return 't2';

  return null;
};

const adaptScheme = (row, towerCode, index) => {
  const anticipo = parsePercent(row?.Enganche);
  const diferido = parsePercent(row?.Diferido);
  const finiquito = parsePercent(row?.['Escrituración']);
  const descuento = parsePercent(row?.Descuento);
  const percentages = [anticipo, diferido, finiquito, descuento];

  if (percentages.some((value) => value === null || value < 0 || value > 100)) {
    throw new Error(`El esquema ${index + 1} de ${towerCode} contiene porcentajes inválidos.`);
  }

  if (Math.abs((anticipo + diferido + finiquito) - 100) > 0.01) {
    throw new Error(`El esquema ${index + 1} de ${towerCode} no suma 100%.`);
  }

  return {
    codigo: `${towerCode}-${anticipo}-${diferido}-${finiquito}-${descuento}`,
    nombre: `${anticipo}% enganche · ${diferido}% diferido · ${finiquito}% escrituración`,
    anticipo,
    diferido,
    finiquito,
    descuento,
  };
};

export const fetchCotizacionSchemes = async (towerValue, { signal } = {}) => {
  const towerCode = getCotizacionTowerCode(towerValue);
  if (!towerCode) {
    throw new Error('La unidad no tiene una torre compatible con el cotizador.');
  }

  const response = await fetch(`${COTIZACION_API_PATH}/${towerCode}`, {
    headers: { Accept: 'application/json' },
    signal,
  });

  if (!response.ok) {
    throw new Error(`No fue posible consultar los esquemas (${response.status}).`);
  }

  const payload = await response.json();
  if (normalizeText(payload?.torre) !== towerCode || !Array.isArray(payload?.data)) {
    throw new Error('La respuesta de esquemas no tiene el formato esperado.');
  }

  return payload.data.map((row, index) => adaptScheme(row, towerCode, index));
};